import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import axios from "../../utils/axiosInstance"; 
import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import { useNavigate, useParams } from "react-router-dom";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import "./withdraw.css";
import { CircularProgress } from "@material-ui/core";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};

const WithdrawAction = (props) => {
  const { open, setOpen, paymentId, userId , onSuccess } = props;
  const useStyleData = makeStyles(stylesData);
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const navigate = useNavigate();
  const classesSweetAlert = useStyleData();
  const [selectStatus, setSelectStatus] = useState("");
  const [alert, setAlert] = useState(null);
  const [statusList, setStatusList] = useState([]);
  const [formData, setFormData] = useState({
    paymentId: paymentId,
    status: "",
    amount: 0,
    adminRemark: "",
    paymentId: "",
    userId: userId
  });
  const [showLoader, setShowLoader] = useState(false);

  console.log("showLoader", showLoader);
  useEffect(() => {
    setFormData({
      paymentId: paymentId,
      userId: userId
    });
    fetchStatus();
  }, [paymentId]);
  const handleSubmitApprove = async (event) => {
    event.preventDefault();
  
    // Basic validation
    if (!selectStatus || selectStatus === "select") {
      return setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={<span style={{ fontSize: "14px", fontWeight: "bold" }}>Please select a payment status.</span>}
          onConfirm={hideAlert}
          onCancel={hideAlert}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={classesSweetAlert.button + " " + classesSweetAlert.success}
        />
      );
    }
  
    if (
      (selectStatus === "partialPay" || selectStatus === "finalPay") &&
      (!formData.amount || isNaN(formData.amount) || Number(formData.amount) <= 0)
    ) {
      return setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={<span style={{ fontSize: "14px", fontWeight: "bold" }}>Please enter a valid amount.</span>}
          onConfirm={hideAlert}
          onCancel={hideAlert}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={classesSweetAlert.button + " " + classesSweetAlert.success}
        />
      );
    }
  
    if (!formData.adminRemark || formData.adminRemark.trim().length === 0) {
      return setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={<span style={{ fontSize: "14px", fontWeight: "bold" }}>Remarks are required.</span>}
          onConfirm={hideAlert}
          onCancel={hideAlert}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={classesSweetAlert.button + " " + classesSweetAlert.success}
        />
      );
    }
  
    setShowLoader(true);
    formData.status = selectStatus;
  
    try {
      const token = localStorage.getItem("token");
  
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/extWalletPayStatusChange`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*"
          }
        }
      );
  
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>
              {res?.data?.message}
            </span>
          }
          onConfirm={() => {
            hideAlert();
            setOpen(false); 
            if (onSuccess) {
              onSuccess();
            }
          }}
          onCancel={() => {
            hideAlert();
            setOpen(false);
          }}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    } catch (err) {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span style={{ fontSize: "14px", fontWeight: "bold" }}>
              {err?.response?.data?.message || "Something went wrong"}
            </span>
          }
          onConfirm={hideAlert}
          onCancel={hideAlert}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    } finally {
      setShowLoader(false);
    }
  };
  
  const fetchStatus = async () => {
    try {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/withdrawl-status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*"
          },
          params: {
            paymentId: paymentId
          }
        }
      );
      console.log(data, "vinash");

      setStatusList(data?.data);
    } catch (error) {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold"
              }}
            >
              {error?.response?.data?.message}
            </span>
          }
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    }
  };
  const hideAlert = () => {
    setAlert(null);
  
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleSimple = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };
  return (
    <div>
      <Modal open={open} keepMounted onClose={handleClose}>
        <Box sx={style}>
          <div>
            <form onSubmit={handleSubmitApprove}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Withdrawal Confirmation
              </Typography>
              <hr style={{ backgroundColor: "blue" }} />
              <h5>Select Payment Status:</h5>
              <select
                name="withdrawStatis"
                id="withdrawStatus"
                style={{ padding: "9px 10px", margin: "7px 16px 6px 6px" }}
                onChange={(event) => setSelectStatus(event.target.value)}
              >
                <option value="select" disabled selected>
                  Select
                </option>
                {statusList?.map((item) => {
                  return (
                    <option value={item}>
                      {item.toString().toUpperCase()}
                    </option>
                  );
                })}
           
              </select>
              {selectStatus === "partialPay" || selectStatus === "finalPay" ? (
                <div>
                  <h5>Enter Partial Payment Amt:</h5>
                  <input
                    type="text"
                    id="amount"
                    style={{
                      width: "45%",
                      height: "100%",
                      margin: "2px 9px 11px 0px",
                      padding: "11px 5px"
                    }}
                    value={formData.amount}
                    onChange={handleSimple}
                  />
                </div>
              ) : (
                ""
              )}
              <br />
              <h5>Remarks</h5>
              <textarea
                type="text"
                id="adminRemark"
                name="adminRemark"
                maxlength="300"
                value={formData.adminRemark}
                style={{
                  width: "100%",
                  height:'100px',
                  margin: "2px 9px 11px 0px",
                 
                }}
                onChange={handleSimple}
              />
             

              {showLoader ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px"
                  }}
                >
                  <CircularProgress />
                </div>
              ) : (
                <button
                  type="submit"
                  className="with-btn"
                  style={{
                    width: "40%",
                    margin: "2px 9px 11px 50%",
                    backgroundColor: "darkorchid",
                    fontSize: "16px",
                    fontFamily: "sans-serif",
                    padding: "16px 5px"
                  }}
                >
                  Submit
                </button>
              )}
            </form>
          </div>
          {alert}
        </Box>
      </Modal>
    </div>
  );
};

export default WithdrawAction;
